import React, { useContext } from 'react';
import { mergeStyles } from 'wix-rich-content-common';
import { s as styles } from './giphy-viewer2.js';
import { RicosContext, RicosViewerContext } from 'ricos-context';
import { GIPHY_TYPE } from './viewer-loadable.js';
import '@loadable/component';
import 'ricos-types';

var GiphyViewer = function GiphyViewer(props) {
  var _useContext = useContext(RicosContext),
    theme = _useContext.theme;
  var Styles = mergeStyles({
    styles: styles,
    theme: theme
  });
  var original = props.componentData.original;
  if (!original.mp4 && !original.gif) {
    return null;
  }
  return /* @__PURE__ */React.createElement("div", {
    "data-hook": "giphyPlayer"
  }, original.mp4 ?
  // video should be treated as an noninteractive git element
  /* eslint-disable jsx-a11y/no-redundant-roles, jsx-a11y/no-interactive-element-to-noninteractive-role*/
  /* @__PURE__ */
  React.createElement("video", {
    role: "img",
    autoPlay: true,
    muted: true,
    loop: true,
    playsInline: true,
    "aria-label": "gif",
    className: Styles.giphy_player,
    src: original.mp4
  }) : /* @__PURE__ */React.createElement("img", {
    role: "img",
    "aria-label": "gif",
    className: Styles.giphy_player,
    src: original.gif,
    alt: "gif"
  }));
};

var Giphy = function Giphy(_ref) {
  var node = _ref.node,
    nodeIndex = _ref.nodeIndex,
    NodeViewContainer = _ref.NodeViewContainer;
  var _useContext = useContext(RicosViewerContext),
    config = _useContext.config;
  return /* @__PURE__ */React.createElement(NodeViewContainer, {
    key: node.id,
    node: node,
    nodeIndex: nodeIndex
  }, /* @__PURE__ */React.createElement(GiphyViewer, {
    componentData: node.gifData,
    settings: config[GIPHY_TYPE]
  }));
};

export { Giphy as default };

import 'wix-rich-content-plugin-giphy/dist/loadable/viewer/es/styles.viewer.min.global.css'